import { render, staticRenderFns } from "./CatalogManagement.vue?vue&type=template&id=19e537bc&"
import script from "./CatalogManagement.vue?vue&type=script&lang=js&"
export * from "./CatalogManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports